﻿// Mowalola-style model toggle — fetches second product image via Shopify API
(function () {
  function initGrid(grid) {
    if (grid.dataset.mowInit) return;
    grid.dataset.mowInit = '1';

    var cardItems = []; // populated after API calls (cards without a slider — single static image)
    var sliderItems = []; // cards with a pltm-card-slider — driven by scrolling to slide 1
    var modelViewActive = false;

    var PERSON_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="7" r="4"/><path d="M12 14c-6 0-8 2.5-8 4v1h16v-1c0-1.5-2-4-8-4z"/></svg>';
    var SHIRT_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M8 2 3 6l2.5 2.5L7 7v13h10V7l1.5 1.5L21 6l-5-4-2 2h-4L8 2z"/></svg>';

    // ── Build toggle UI ──────────────────────────────────────────
    var wrap = document.createElement('div');
    wrap.className = 'pltm-toggle-wrap';

    var label = document.createElement('label');
    label.className = 'pltm-view-toggle';
    label.setAttribute('aria-label', 'Toggle between product-only and on-body view');

    var input = document.createElement('input');
    input.type = 'checkbox';
    input.className = 'pltm-toggle-input';

    var track = document.createElement('span');
    track.className = 'pltm-toggle-track';

    // Icon lives inside the knob itself, so it slides with it instead of being a separate
    // element that has to be kept in sync with the knob's position.
    var knob = document.createElement('span');
    knob.className = 'pltm-toggle-knob';
    knob.innerHTML = SHIRT_ICON;
    track.appendChild(knob);

    label.appendChild(input);
    label.appendChild(track);
    wrap.appendChild(label);

    // Insert directly before the product grid (below section heading)
    grid.parentNode.insertBefore(wrap, grid);

    function applyView() {
      cardItems.forEach(function (item) {
        if (modelViewActive) {
          item.firstImg.style.opacity = '0';
          item.overlay.style.opacity = '1';
        } else {
          item.firstImg.style.opacity = '';
          item.overlay.style.opacity = '0';
        }
      });
      sliderItems.forEach(function (item) {
        var target = item.slides[modelViewActive ? 1 : 0];
        if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    }

    // ── Toggle listener ──────────────────────────────────────────
    input.addEventListener('change', function () {
      modelViewActive = input.checked;
      knob.innerHTML = modelViewActive ? PERSON_ICON : SHIRT_ICON;
      applyView();
    });

    // ── Wire up cards ──────────────────────────────────────────
    var cards = grid.querySelectorAll('.card-wrapper');
    cards.forEach(function (card) {
      // Cards with the full pltm-card-slider carousel already render every photo as a real slide
      // (see snippets/card-product.liquid) — the toggle just scrolls straight to slide index 1
      // (the model shot) instead of injecting a competing overlay <img>, which previously broke
      // the slider's own scroll state and meant the toggle silently did nothing on these cards.
      var sliderEl = card.querySelector('.pltm-card-slider');
      if (sliderEl) {
        var slidesUl = sliderEl.querySelector('ul.slider');
        var slides = slidesUl ? slidesUl.querySelectorAll('.slider__slide') : [];
        if (slides.length > 1) {
          sliderItems.push({ card: card, slides: slides });
        }
        return;
      }

      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      var match = link.getAttribute('href').match(/\/products\/([^?#\/]+)/);
      if (!match) return;
      var handle = match[1];

      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          if (!product.images || product.images.length < 2) return;

          var firstImg = card.querySelector('.card__media img, .media img');
          if (!firstImg) return;

          // Create overlay for the second (model) image
          var overlay = document.createElement('img');
          overlay.src = product.images[1];
          overlay.alt = product.title;
          overlay.style.cssText = [
            'position:absolute',
            'top:0',
            'left:0',
            'width:100%',
            'height:100%',
            'object-fit:cover',
            'object-position:center top',
            'opacity:0',
            'z-index:2',
            'transition:opacity 0.25s',
          ].join(';');

          var mediaEl = card.querySelector('.card__media .media') || card.querySelector('.media');
          if (!mediaEl) return;

          mediaEl.appendChild(overlay);
          card.classList.add('has-secondary-image');

          var item = { card: card, firstImg: firstImg, overlay: overlay };
          cardItems.push(item);

          // If toggle is already on when the image loads, show it immediately
          if (modelViewActive) {
            firstImg.style.opacity = '0';
            overlay.style.opacity = '1';
          }

        })
        .catch(function () {});
    });
  }

  function init() {
    if (window.pltmModelToggleEnabled === false) return;
    document.querySelectorAll('.product-grid').forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
